import * as yup from 'yup';
import { capitalize } from 'lodash/string';
import appNames from '../../constants/appNames';
import businessLines from '../../constants/businessLines';

const helpFormSchema = yup.object().shape({
  firstName: yup.string().required('Required').label('Last Name'),
  lastName: yup.string().required('Required').label('Last Name'),
  email: yup.string().email().required('Required').label('Email'),
  subject: yup.string().required('Required').label('Subject'),
  description: yup.string().required('Required').label('Description'),
  application: yup.string().oneOf(appNames).required().label('Application'),
  businessLine: yup.string().oneOf(businessLines.map(capitalize)).required().label('businessLine'),
  priority: yup.number().required('Required').label('Priority'),
  recaptcha: process.env.NODE_ENV === 'test' ? null : yup.string().nullable().required('Required'),
});

export default helpFormSchema;
